export default __webpack_public_path__ + "media/images/theme/wordmark_dark-c1523edb6ca093953d0c45ab2c101051.png";